<div class="flex row" *ngIf="!title">
  <div class="pr-0">
    <div
      class=""
      *ngIf="organisation_logo"
      [style.display]="screenWidth >= 800 ? 'block' : 'none'"
    >
      <img src="{{ organisation_logo }}" onError="this.src=''" />
    </div>
  </div>
  <div class="ml-4">
    <h1 *ngIf="organisation_name" class="text-dark">
      {{ organisation_name }}
      <small *ngIf="reg_no == 'yes'">{{
        organisation_address ? '(' + organisation_address.reg_no + ')' : ''
      }}</small>
    </h1>
    <h1 [class]="organisation_address ? ' font-size-h6 text-black-50 ' : ''">
      {{
        organisation_address ? organisation_address.additional_info.city : ''
      }},
      {{
        organisation_address ? organisation_address.additional_info.zipcode : ''
      }}
    </h1>
  </div>
</div>

<h1 *ngIf="title">{{ title }}</h1>
